import React, {createContext, useEffect, useState, ReactNode, Context} from "react";

const GeneralContext = createContext<null|{}> (null);

interface IGeneralContext {

    children: ReactNode | ReactNode[];
}

function GeneralContextProvider(props : IGeneralContext) {

    const [ data  , setData ] = useState<{} |null >(null);


    useEffect(() => {
        fetch('public/data.json')
            .then((response) => response.json())
            .then((jsonData) => {
                setData(jsonData);
            })
            .catch((error) => console.error('Error fetching data:', error));
    }, []);



    return (
        <GeneralContext.Provider value={data}>
            {props.children}
        </GeneralContext.Provider>
    )

}

export { GeneralContextProvider };
export default GeneralContext;